import moment from "moment";

const AGE = () => {
  return moment().diff("1998-06-23", "years", false);
};

export const CV = [
  `My name is Eloïse, I'm ${AGE()} years old and I'm from Belgium.`, 
  "I started baking around 3 when I was visiting my grandma in France with whom I was making pies all the time. With time I started baking more and more and it turned into a passion.",
  "At 17, I decided to improve my techniques and learn even more of the pastry world by studying in a pastry school in Brussels.",
  "After 4 years, I finally graduated from pastry, bakery, chocolate making, ice cream making and confectionery.",
  "During those years I worked in several pastry and chocolate places in Belgium, learning new techniques and improving my creativity.",
  "Now in Denmark, I would like to share my passion and my cakes to everyone who wants to discover and enjoy French pastry. The most important thing to me: Everything is HOMEMADE!",
  "My menu consists mostly of classics and timeless French specialities and I look forward to expand my selection. So keep an eye on it!","And come taste a bit of France!"
];
